import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "italic" }, [
      _createElementVNode("path", {
        id: "vector",
        d: "M6.27586 2.33398L9.66667 2.33398L13 2.33398M3 13.6673H6.33333L9.72414 13.6673M9.61731 2.50178L6.38189 13.5022",
        stroke: "currentColor",
        "stroke-linecap": "square"
      })
    ], -1)
  ])))
}
export default { render: render }